import React, { useState } from "react";
import { CircularProgress, Avatar } from "@mui/material";
import Axios from "axios";
import { useNavigate } from "react-router-dom";

const returnDate = (d) => {
  return new Date(d).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};
const AllInteractions = () => {
  const [activity, setactivity] = React.useState(null);
  const [sorttype, setsorttype] = useState("maximum");

  const fetchStats = async () => {
    const { data } = await Axios({
      method: "get",
      url: `/api/activity/allinteractions?sorttype=${sorttype}`,
    });
    setactivity(data.data);
  };
  const navigate = useNavigate();
  React.useEffect(() => {
    fetchStats();
  }, [sorttype]);
  if (activity === null) {
    return <CircularProgress />;
  }
  return (
    <>
      <div className="container admin-user-activity">
        <h3>User Chat Interactions</h3>
        {activity?.length > 0 ? (
          <>
            <div className="">
              <select
                id="typeDropdown"
                className="h-40px"
                value={sorttype}
                onChange={(e) => setsorttype(e.target.value)}
              >
                <option value="maximum"> Maximum Interactions</option>
                <option value="recent"> Recent Interactions</option>
              </select>
            </div>
            <table className="plan_table mt-24">
              <thead className="plan_thead activityplan_thead">
                <tr>
                  <th>1st User</th>
                  <th>2nd User</th>
                  <th>Message Count</th>
                  <th>Last Interaction</th>
                  <th>ConnectionID</th>
                </tr>
              </thead>
              {activity.length > 0 &&
                activity.map((res, i) => {
                  return (
                    <tr key={i} className="my-2 pt-2">
                      <td
                        onClick={() =>
                          navigate(
                            `/admin/user-activity?tab=13&userid=${res.senderDetails?._id}`
                          )
                        }
                        className="pointer my-2 pt-2"
                      >
                        <Avatar
                          src={
                            res.senderDetails ? res.senderDetails.avatar : ""
                          }
                        />
                        {res.senderDetails
                          ? `${res.senderDetails.name} (${res.senderDetails.type}) `
                          : ""}
                      </td>
                      <td
                        onClick={() =>
                          navigate(
                            `/admin/user-activity?tab=13&userid=${res.receiverDetails?._id}`
                          )
                        }
                        className="pointer my-2 pt-2"
                      >
                        <Avatar
                          src={
                            res.receiverDetails
                              ? res.receiverDetails.avatar
                              : ""
                          }
                        />
                        {res.receiverDetails
                          ? `${res.receiverDetails.name} (${res.receiverDetails.type}) `
                          : ""}
                      </td>
                      <td className=" my-2 pt-2">{res.messageCount}</td>
                      <td className=" my-2 pt-2">
                        {returnDate(res.lastInteractedAt)}
                      </td>
                      <td className=" my-2 pt-2">{res._id}</td>
                    </tr>
                  );
                })}
            </table>
          </>
        ) : (
          <h2>No Reports</h2>
        )}
      </div>
    </>
  );
};

export default AllInteractions;
